import { Box, Typography } from '@mui/material';

type ContentLabelAndValueProps = {
  value: string | undefined;
  label: string;
};

export const ContentLabelAndValue = (props: ContentLabelAndValueProps) => {
  const { label, value } = props;
  if (!value) return null;
  return (
    <Box display='flex' flexDirection='column' pb={1}>
      <Typography variant='body1' fontWeight={(thm) => thm.typography.fontWeightBold}>
        {label}:
      </Typography>
      <Typography variant='body1'>{value}</Typography>
    </Box>
  );
};
